import { render, staticRenderFns } from "./SandboxTypingIndicator.vue?vue&type=template&id=c392848c&"
import script from "./SandboxTypingIndicator.vue?vue&type=script&setup=true&lang=js&"
export * from "./SandboxTypingIndicator.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c392848c')) {
      api.createRecord('c392848c', component.options)
    } else {
      api.reload('c392848c', component.options)
    }
    module.hot.accept("./SandboxTypingIndicator.vue?vue&type=template&id=c392848c&", function () {
      api.rerender('c392848c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/onboardingShell/steps/sandbox/SandboxTypingIndicator.vue"
export default component.exports